export const C_SEARCH_PARAM = 'c_search';
